<div class="cip-chart-labelled" *transloco="let t">
  @if (showLabels) {
    <div class="left-labels">
      <div class="left-label">
        <p class="label-name">{{t('ciprofile_domains.know')}}</p>
        <i class="fa-solid fa-globe-pointer icon"></i>
      </div>
      <div class="left-label">
        <p class="label-name">{{t('ciprofile_domains.act')}}</p>
        <i class="fa-solid fa-person-running icon"></i>
      </div>
    </div>
  }

  <div class="cip-chart" [ngClass]="{micro:scale==='micro'}" style="--chart-size: {{chartSize}}%;">
    @for (row of rows; track row) {
      <div [class]="row.rowClasses">
        <div class="quarter-row">
          @for (domain of row.domains; track domain; let domainIndex = $index) {
            <svg [class]="row.domainClasses[domainIndex] + ' traffic-light-'+domain.scaleSteps + 'h-auto'" xmlns="http://www.w3.org/2000/svg" width="49%" viewBox="0 0 180 180">
              <!-- Domain -->
              <g
                class="domain"
                [ngClass]="{'highlight': highlightedElementSlug === domain.slug, 'lowlight': highlightedElementSlug && highlightedElementSlug !== domain.slug}"
                (mouseenter)="setCurrentSelection({subdomain: null, domain: domain})"
                (mouseleave)="setCurrentSelection({subdomain: null, domain: null})"
                (click)="doSelection({subdomain: null, domain: domain}, null)"
                >
                <path  class="domain-fill traffic-light-{{domain.scaleSteps}} {{domain.score === null ? 'disabled' : ''}}" [ngClass]="{'highlight': highlightedElementSlug === domain.slug, 'lowlight': highlightedElementSlug && highlightedElementSlug !== 'all' && highlightedElementSlug !== domain.slug}" [attr.d]="domainOuterPath"/>
                <path class="domain-stroke" fill-rule="evenodd" clip-rule="evenodd" [attr.d]="domainOuterPathBorder" />
                <!-- Subdomain -->
                @for (subdomain of domain.subdomains; track subdomain) {
                  <g
                    class="subdomain {{subdomain.score === null ? 'disabled' : ''}}"
                    [ngClass]="{'highlight': highlightedElementSlug === subdomain.slug, 'lowlight': highlightedElementSlug && highlightedElementSlug !== 'all' && highlightedElementSlug !== subdomain.slug}"
                    [style.--transform-increment]="subdomain.rotation+'deg'"
                    (mouseenter)="setCurrentSelection({subdomain: subdomain, domain: domain})"
                    (mouseleave)="setCurrentSelection({subdomain: null, domain: domain})"
                    (click)="doSelection({subdomain: subdomain, domain: domain},$event)">
                    <path class="fill traffic-light-{{currentSubdomain?.slug == subdomain.slug ? subdomain.scaleSteps : domain.scaleSteps }}"
                      [ngClass]="{'highlight': highlightedElementSlug === domain.slug, 'lowlight': highlightedElementSlug && highlightedElementSlug !== 'all' && highlightedElementSlug !== domain.slug && highlightedElementSlug !== subdomain.slug}"
                      [attr.d]="subdomainPathSomething"/>
                    <path class="stroke" fill-rule="evenodd" clip-rule="evenodd" [attr.d]="subdomainPathInnerBackground" />
                    <g class="progress">
                      @for (bar of barPathDefinitionsReversed; track bar; let i = $index) {
                        <path class="line" [ngClass]="{active: subdomain.scaleSteps > barPathDefinitionsReversed.length - (i+1)}" [attr.d]="bar" />
                        }
                      </g>
                    </g>
                  }
                  <!-- End of subdomain -->
                </g>
                <!-- End of domain -->
              </svg>
            }
          </div>
        </div>
      }

      <div class="central-content-holder">
        <!-- doughnut progress -->
        <div class="progress-pie-doughnut {{'traffic-light-'+currentSelection?.scaleSteps}} {{currentSelection?.score === null ? 'disabled' : ''}}" [ngClass]="{'lowlight': highlightedElementSlug && highlightedElementSlug !== 'all' && highlightedElementSlug !== 'total' && highlightedElementSlug !== currentDomain?.slug}" style="--progress-value: {{currentSelection?.score}}">
          <svg width="100%" height="100%" viewBox="0 0 38 38" class="doughnut">
            <circle [class]="'doughnut-ring traffic-light-'+currentSelection?.scaleSteps" cx="19" cy="19" r="16" fill="blue" stroke-width="5"></circle>
            <circle [class]="'doughnut-segment stroke traffic-light-'+currentSelection?.scaleSteps" cx="19" cy="19" r="16" fill="green" stroke-width="5" stroke-dashoffset="24.8" [style.strokeDasharray]="currentSelection ? currentSelection.score+' '+(100-currentSelection.score) : null"></circle>
            <circle class="doughnut-hole" cx="19" cy="19" r="16.1"></circle>
          </svg>
        </div>
        <!-- End of doughnut progress -->
        <!-- ciprofile-icon -->
        <!-- <i class="fa-kit fa-ciprofile brain"></i> -->
        @if (!currentSelection?.iconClasses) {
          <svg class="ciprofile-icon h-auto"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-3 -3 110 110"
            width="50%"
            fill="none">
            <g id="Icon">
              <path d="m93.73,51.64c0,21.61-16.29,39.41-37.26,41.81v-12.15c14.3-2.31,25.22-14.69,25.23-29.65h-9.66c-.01,11.26-9.13,20.39-20.4,20.39s-20.38-9.13-20.39-20.39h-9.66c0,14.96,10.93,27.34,25.22,29.65v12.15c-20.96-2.4-37.25-20.2-37.25-41.81,0-23.24,18.84-42.09,42.08-42.09,17.28,0,32.13,10.42,38.6,25.31l8.19-5.11C90.19,12.17,72.34,0,51.64,0,23.12,0,0,23.12,0,51.64s23.12,51.64,51.64,51.64,51.65-23.12,51.65-51.64h-9.56Z"/>
              <circle cx="51.65" cy="51.65" r="8.37"/>
            </g>
          </svg>
        }
        <!-- <svg class="ciprofile-icon h-auto"
        *ngIf="!currentSelection?.iconClasses"
        xmlns="http://www.w3.org/2000/svg"
        width="42%"
        viewBox="0 0 73 66"
        fill="none">
        <g>
          <path d="M67.57 40.74C73.40 35.72 73.89 27.75 68.73 22.15C68.54 21.94 68.43 21.54 68.48 21.26C68.97 18.46 68.13 16.17 65.90 14.36C65.64 14.16 65.44 13.81 65.36 13.49C64.75 11.06 63.22 9.55 60.81 8.84C60.51 8.74 60.18 8.50 60.00 8.24C58.88 6.57 57.39 5.42 55.36 5.14C54.29 4.99 53.18 5.12 52.01 5.12C49.72 2.01 47.51 1.26 43.47 2.26C43.29 2.31 43.00 2.20 42.84 2.07C39.69 -0.49 35.54 -0.40 32.60 2.33C32.29 2.62 32.09 2.62 31.72 2.44C28.45 0.84 24.83 1.56 22.46 4.29C22.12 4.68 21.88 4.73 21.41 4.55C17.51 3.11 13.32 4.87 11.69 8.65C11.51 9.07 11.26 9.22 10.86 9.34C8.13 10.15 6.49 11.94 5.94 14.72C5.89 14.95 5.63 15.52 5.41 15.62C2.61 16.92 1.35 18.50 0.79 21.87C0.27 25.02 1.98 27.47 4.72 29.14C4.95 29.28 5.16 29.53 5.27 29.77C7.11 34.04 10.52 36.07 15.07 36.42C17.20 36.59 19.23 36.08 21.30 35.05C21.19 35.32 21.15 35.41 21.11 35.50C19.84 38.67 20.33 41.57 22.75 44.00C25.18 46.41 28.11 46.97 31.33 45.70C31.81 45.51 32.00 45.71 32.26 45.98C35.53 49.44 37.62 53.47 38.33 58.18C38.66 60.41 38.67 60.41 40.84 60.41C42.68 60.41 42.65 60.41 42.74 58.59C42.82 56.96 43.28 55.45 44.23 54.05C46.62 56.88 49.54 58.06 53.10 56.92C56.48 55.83 58.19 53.33 58.53 49.85C58.67 49.87 58.81 49.89 58.95 49.93C61.55 50.66 63.86 50.13 65.75 48.21C67.62 46.32 68.11 44.05 67.31 41.53C67.19 41.15 67.29 40.97 67.56 40.74L67.57 40.74ZM50.18 30.06C47.77 30.07 45.35 30.06 42.94 30.06C42.77 30.06 42.45 30.06 42.21 30.06C42.48 30.78 42.67 31.29 42.70 31.36C43.99 34.75 45.29 38.14 46.58 41.54C46.65 41.71 46.73 41.88 46.78 42.06C46.91 42.53 46.91 42.98 46.40 43.24C45.92 43.48 45.52 43.35 45.18 42.95C43.90 41.50 42.62 40.05 41.34 38.59C37.85 34.64 34.37 30.69 30.90 26.72C30.66 26.45 30.42 26.12 30.33 25.78C30.12 24.95 30.74 24.33 31.78 24.32C34.19 24.31 36.60 24.32 39.01 24.32C39.19 24.32 39.51 24.32 39.75 24.32C39.48 23.60 39.28 23.09 39.26 23.02C37.97 19.63 36.67 16.24 35.38 12.85C35.31 12.67 35.23 12.50 35.18 12.32C35.05 11.85 35.05 11.40 35.56 11.14C36.04 10.90 36.44 11.04 36.78 11.43C38.06 12.89 39.34 14.33 40.62 15.79C44.10 19.74 47.58 23.70 51.06 27.66C51.30 27.93 51.54 28.26 51.63 28.60C51.84 29.43 51.22 30.05 50.18 30.06Z" style="fill:var(--primary)"/>
        </g>
      </svg> -->
      <!-- End of ciprofile-icon -->

      @if (currentSelection) {
        <div class="subdomain-icon w-100">
          @for (object of concatenatedDomainsAndSubdomains(); track object) {
            <span>
              @if (object.iconClasses === currentSelection.iconClasses) {
                <span><i [class]="object.iconClasses + ' display-3 icon'"></i></span>
              }
            </span>
          }
          @if (currentSelection) {
            <p class="d-none d-md-block">
              <span *transloco="let t">{{t(currentSelection.titleTranslationKey)}}</span>
            </p>
          }
        </div>
      }

    </div>
  </div>

  @if (showLabels) {
    <div class="right-labels">
      <div class="right-label">
        <i class="fa-solid fa-heart icon"></i>
        <p class="label-name">{{t('ciprofile_domains.love')}}</p>
      </div>
      <div class="right-label">
        <i class="fa-solid fa-eye icon"></i>
        <p class="label-name">{{t('ciprofile_domains.think')}}</p>
      </div>
    </div>
  }
</div>